import {useContext, useState, useEffect} from "react";
import { UserContext } from '../Context/UserContext';
import {useNavigate} from "react-router-dom"
import HomeGameBar from "./HomeGameBar";
import TableImage from "../images/new-hitter-ratings.png"
import GraphImage from "../images/hitter trends screenshot.png"
import SignupLoginButtons from "./SignupLoginButtons";
import TimeframeImage from "../images/timeframe select screenshot.png"
import PitcherTableImage from "../images/new-pitcher-ratings.png"
import TeamTrendsImage from "../images/new team trends pic.png"
import CreateMatchupImage from "../images/create matchup screenshot.png"
import PitchReportImage from "../images/schwarber vs skubal pitch report.png"
import NavBar from "./NavBar";
import TweetImage1 from "../images/tweet 1.png"
import TweetImage4 from "../images/tweet 4.png"
import TweetImage7 from "../images/tweet 7.png"
import TweetImage8 from "../images/tweet 8.png"
import TweetImage9 from "../images/tweet 9.png"
import TweetImage10 from "../images/tweet 10.png"
import TweetImage11 from "../images/tweet 11.png"
import TweetImage12 from "../images/tweet 12.png"
import { useIsMobile } from "../hooks/useIsMobile"
import '../styles/home.css'

function Home() {
    const isMobile = useIsMobile(768)
    const {state, isActiveSub} = useContext(UserContext);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    //console.log('state', state)
    const tweetImages = [TweetImage1, TweetImage4, TweetImage7, TweetImage8, TweetImage9, TweetImage10, TweetImage11, TweetImage12]
    const featureBoxImages = [TableImage, GraphImage, PitchReportImage, CreateMatchupImage, TeamTrendsImage, TimeframeImage, PitcherTableImage]
    const featureBoxHeaders = ["Find Elite Matchups", "Make Smarter Decisions", "Detailed Pitch Reports", "Pick Your Pitchers", "Team Data", "Stay Current", "Mound Metrics"]
    const extraFeatureHeader = ["Discover Our Unique Ratings", "", "", "", "", ""]
    const featureBoxDescriptors = ["Explore Our In-Depth Guide and Learn Ways to Use the Ratings", "Leverage Hitter and Pitcher Trends Showing How Often The Batter or Pitcher Succeeds in a Given Matchup", "See Which Hitters Stack Up Best vs the Pitchers Pitch Arsenal", "Evaluate Matchup Ratings for Any Pitcher and Team You Select", "Analyze Moneyline Trends and Run Scoring Patterns" , "Use Both Default and Current Season Ratings", "Unlock Pitcher Ratings for Insights on Strikeout Props and More!"]
    const extraPtag = ["", "", "", "", "", "The default dataset offers larger sample sizes, while the current season dataset focuses on recent performance", ""]

    const navigate = useNavigate()

    function handleImageNavigation(index) {
        if (index === 0) {
            navigate('/guide')
            window.scrollTo(0, 0)
        }
        else return
    }

    function handlePremiumNavigation() {
        navigate('/checkout')
        window.scrollTo(0, 0)
    }

    function handleHeaderNavigation(index) {
        if (index === 0) {
            navigate('/ratings/hitters')
            window.scrollTo(0, 0)
        }
        else return
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % tweetImages.length)
        }, 6000)

        return () => clearInterval(intervalId)
    }, [tweetImages.length])

    function getImageID(index) {
        switch (index) {
            case 0:
                return "newHomeTableImage"
            case 1:
                return "graphImage"
            case 2: 
                return "pitchReportImage"
            case 3:
                return "createMatchupScreenshot"
            case 4:
                return "teamTrendsImage"
            case 5:
                return "timeframeImage"
            case 6:
                return "pitcherTableImage"
            default:
                break;
        }
    }

    return (
        <div className="homeContainer">
            {isMobile && (
                <div className="mobileTopRow">
                    <NavBar />
                    <HomeGameBar />
                </div>
            )}
            {!isMobile && (
                <div className="desktopTopRow">
                    <HomeGameBar />
                    <NavBar />
                </div>
            )}
            <div className="newHomeHeader">
                <h1>MLB Betting & DFS Tools <br />Built for Smarter Decisions</h1>
                <ul className="addValueList">
                    <li>Advanced Data and Matchup Insights</li>
                    <li>Reduce Guesswork and Identify Value</li>
                </ul>
                {/* <h3 style={{color: "lightblue", fontSize: "1.35rem"}}>Advanced Data and Matchup Insights <br /> Reduce Guesswork and Identify Value</h3> */}
            </div>
            {!state.loggedIn && (
                <div>
                    <div className="newHomePremium">
                        <p style={{textAlign: "center"}}>Unlock Premium Tools & Features</p>
                        <button onClick={handlePremiumNavigation}>View Plans</button>
                    </div>
                    <SignupLoginButtons className="signUpLoginButtons" />
                </div>
            )}
            {state.loggedIn && !isActiveSub && (
                <div className="newHomePremium">
                    <p style={{textAlign: "center"}}>Unlock Premium Tools & Features</p>
                    <button onClick={handlePremiumNavigation}>View Plans</button>
                </div>
            )}
            <div className="featuresContainer">
                {featureBoxHeaders.map((header, index) => (
                    <div className="soloFeatureBox" key={index}>
                        <h2>{header}</h2>
                        <h3 onClick={() => handleHeaderNavigation(index)}>{extraFeatureHeader[index]}</h3>
                        <p id="featureBoxDescriptor">{featureBoxDescriptors[index]}</p>
                        <p id="extraFeatureBoxDescriptor">{extraPtag[index]}</p>
                        <div className="imageContainer">
                            <img id={getImageID(index)} onClick={() => handleImageNavigation(index)} src={featureBoxImages[index]} alt="features" ></img>
                        </div>
                    </div>
                ))}
                <div className="testimonialsBox">
                    <h2>What Our Users Say About Us</h2>
                    <img id="tweetImage" src={tweetImages[currentImageIndex]} alt="tweet testimonials"></img>
                </div>
            </div>
        </div>
    )
}

export default Home